import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CheckinModeState {
  isOpen: boolean;
  searchQuery: string;
  selectedPerson: any;
  checkinHistory: any[];
  isProcessing: boolean;
  stats: {
    total: number;
    checkedIn: number;
    pending: number;
    percentage: number;
  };
  quickActions: {
    qrScanner: boolean;
    voiceSearch: boolean;
    autoFocus: boolean;
    soundEnabled: boolean;
  };
}

const initialState: CheckinModeState = {
  isOpen: false,
  searchQuery: "",
  selectedPerson: null,
  checkinHistory: [],
  isProcessing: false,
  stats: {
    total: 0,
    checkedIn: 0,
    pending: 0,
    percentage: 0,
  },
  quickActions: {
    qrScanner: false,
    voiceSearch: false,
    autoFocus: true,
    soundEnabled: true,
  },
};

const checkinModeSlice = createSlice({
  name: "checkinMode",
  initialState,
  reducers: {
    openCheckinMode: (state) => {
      state.isOpen = true;
    },
    closeCheckinMode: (state) => {
      state.isOpen = false;
      state.searchQuery = "";
      state.selectedPerson = null;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSelectedPerson: (state, action: PayloadAction<any>) => {
      state.selectedPerson = action.payload;
    },
    addCheckinHistory: (state, action: PayloadAction<any>) => {
      state.checkinHistory.unshift(action.payload);
      // Manter apenas os últimos 10 check-ins
      if (state.checkinHistory.length > 10) {
        state.checkinHistory = state.checkinHistory.slice(0, 10);
      }
    },
    setProcessing: (state, action: PayloadAction<boolean>) => {
      state.isProcessing = action.payload;
    },
    updateStats: (
      state,
      action: PayloadAction<Partial<CheckinModeState["stats"]>>
    ) => {
      state.stats = { ...state.stats, ...action.payload };
    },
    toggleQuickAction: (
      state,
      action: PayloadAction<keyof CheckinModeState["quickActions"]>
    ) => {
      state.quickActions[action.payload] = !state.quickActions[action.payload];
    },
    clearCheckinHistory: (state) => {
      state.checkinHistory = [];
    },
  },
});

export const {
  openCheckinMode,
  closeCheckinMode,
  setSearchQuery,
  setSelectedPerson,
  addCheckinHistory,
  setProcessing,
  updateStats,
  toggleQuickAction,
  clearCheckinHistory,
} = checkinModeSlice.actions;

export default checkinModeSlice.reducer;
